<button
  (click)="handleClick()"
  style="width: 150px"
  class="fdx-c-button fdx-c-button--primary-outline"
  [ngClass]="{ 'fdx-c-button--is-loading': isLoading }"
  [disabled]="isLoading || isDisabled">
  <span class="fdx-c-button__loading-container">
    <span class="fdx-c-button__title">{{ buttonText }}</span>
    <!-- <span class="fdx-c-button__loading">
      <div class="fdx-c-loader fdx-c-loader--white fdx-c-loader--medium"></div>
    </span> -->
  </span>
</button>
